import config from '../common/config';

function Entity(img, x = 0, y = 0, dx = 0, dy = 0) {
    if (this.constructor === Entity) {
        throw new Error(`${this.constructor.name}: can not create instance of abstract class`);
    }
    this.image = img;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
}

Entity.prototype.move = function () {
    this.x += this.dx * config.speed;
    this.y += this.dy * config.speed;
};

Entity.prototype.getMinDistance = function (entity) {
    const max = Math.max(Math.abs(this.dx), Math.abs(this.dy),
        Math.abs(entity.dx), Math.abs(entity.dy));
    const part = 1 / max;
    const vectorFirst = {};
    const vectorSecond = {};
    let minDist = Infinity;
    let x;
    let y;
    let distSquared;
    vectorFirst.x = this.x + this.width / 2;
    vectorFirst.y = this.y + this.height / 2;
    vectorSecond.x = entity.x + entity.width / 2;
    vectorSecond.y = entity.y + entity.height / 2;
    for (let percent = 0; percent < 1; percent += part) {
        x = (vectorFirst.x + this.dx * percent) - (vectorSecond.x + entity.dx * percent);
        y = (vectorFirst.y + this.dy * percent) - (vectorSecond.y + entity.dy * percent);
        distSquared = x * x + y * y;
        minDist = Math.min(minDist, distSquared);
    }

    return Math.sqrt(minDist);
};

export default Entity;
